var _ellipse, _path, _path2, _path3, _path4, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiskorexplosure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 24.3943C14.5 24.216 14.5432 24.0402 14.6258 23.8821L24.1707 5.6224C24.7318 4.54891 26.2682 4.54891 26.8293 5.6224L36.3742 23.8821C36.4568 24.0402 36.5 24.216 36.5 24.3943C36.5 25.005 36.005 25.5 35.3943 25.5H15.6057C14.995 25.5 14.5 25.005 14.5 24.3943Z",
    fill: "white",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71973 20.5H11.3232V10.7969H7.71973V20.5ZM9.52148 10.2607C10.541 10.2607 11.3145 9.52246 11.3145 8.55566C11.3145 7.58887 10.541 6.85059 9.52148 6.85059C8.50195 6.85059 7.72852 7.58887 7.72852 8.55566C7.72852 9.52246 8.50195 10.2607 9.52148 10.2607ZM12.6768 20.5H16.2803V10.7969H12.6768V20.5ZM14.4785 10.2607C15.498 10.2607 16.2715 9.52246 16.2715 8.55566C16.2715 7.58887 15.498 6.85059 14.4785 6.85059C13.459 6.85059 12.6855 7.58887 12.6855 8.55566C12.6855 9.52246 13.459 10.2607 14.4785 10.2607Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0715 11C24.4921 11 24.0339 11.4909 24.0739 12.0689L24.4194 17.0689C24.4557 17.5932 24.8915 18 25.4171 18H25.5661C26.0905 18 26.5259 17.5948 26.5635 17.0717L26.923 12.0717C26.9646 11.4927 26.5061 11 25.9255 11H25.0715Z",
    stroke: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 21,
    r: 1.5,
    stroke: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskorexplosure);
export default __webpack_public_path__ + "static/media/riskorexplosure.63aba0c84f88ce06aea9317c4840224a.svg";
export { ForwardRef as ReactComponent };